export enum UsageEventDimension {
    Path = 'path',
    Method = 'method',
    Status = 'status',
    Service = 'service',
    ResourceType = 'resourceType',
    Country = 'country',
    ContinentCode = 'continentCode',
    City = 'city',
    Region = 'region',
    Hostname = 'hostname',
    Ip = 'ip',
    OsName = 'osName',
    ClientType = 'clientType',
    ClientName = 'clientName',
    DeviceName = 'deviceName',
    Sdk = 'sdk',
    SdkVersion = 'sdkVersion',
    TeamId = 'teamId',
    ResourceId = 'resourceId',
    Protocol = 'protocol',
    QueryKeys = 'queryKeys',
    Accept = 'accept',
    AcceptLanguage = 'acceptLanguage',
    PostalCode = 'postalCode',
    Latitude = 'latitude',
    Longitude = 'longitude',
    TimeZone = 'timeZone',
    WeatherCode = 'weatherCode',
    Isp = 'isp',
    AutonomousSystemNumber = 'autonomousSystemNumber',
    AutonomousSystemOrganization = 'autonomousSystemOrganization',
    ConnectionType = 'connectionType',
    ConnectionUsageType = 'connectionUsageType',
    ConnectionOrganization = 'connectionOrganization',
}
